import notificationQueries from '@apis/queries/notificationQueries';
import AuthGuard from '@components/AuthGuard';
import Image from '@components/Image';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useUser from '@hooks/auth/useUser';
import useAppCustom from '@hooks/useAppCustom';
import { Link } from '@stackflow/link';
import { isSidebarOpenAtom } from '@states/uiAtoms';
import { useQuery } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';

import BellIcon from './BellIcon';
import MenuIcon from './MenuIcon';

function Header() {
    const setSidebar = useSetAtom(isSidebarOpenAtom);
    const openSidebar = () => setSidebar(true);
    const { logo } = useAppCustom().main;
    const { user } = useUser();
    const { data } = useQuery({
        ...notificationQueries.unread(),
        enabled: !!user,
    });
    return (
        <Container>
            <SideButton onClick={openSidebar}>
                <MenuIcon/>
            </SideButton>
            {logo && (<LogoImage src={logo} alt='logo' />)}
            <AuthGuard css={css`width: 24px;`}>
                <Link activityName='NotificationActivity'
                    activityParams={{}} >
                    <SideButton>
                        <BellIcon/>
                        {data?.hasUnread && (<Dot/>)}
                    </SideButton>
                </Link>
            </AuthGuard>
        </Container>
    );
}

const Container = styled.header`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: calc(var(--spacing-4) + var(--safe-area-top)) var(--spacing-6) var(--spacing-4);
    align-items: flex-end;
    background-color: var(--color-white);
    gap: var(--spacing-4);
`;

const SideButton = styled.button`
    align-items: center;
    background: none;
    display: flex;
    height: 24px;
    justify-content: center;
    padding: 0;
    width: 24px;
    min-width: 24px;
    position: relative;
`;

const LogoImage = styled(Image)`
    height: 30px;
    object-fit: contain;
    width: 100%;
`;

const Dot = styled.div`
    width: 8px;
    height: 8px;
    position: absolute;
    background-color: ${colors.red};
    right: 0;
    top: 0;
    border-radius: 4px;
`;

export default Header;
